import React from "react";
import numeral from "numeral";
import styled, { css } from "styled-components";
import HideOnCloud from "util/conditional/HideOnCloud";
import { Alert } from "components/bootstrap";
import { IndexerClusterHealthSummary } from "components/indexers";
export const StyledAlert = styled(Alert)(
  ({ theme }) => css`
    margin-top: ${theme.spacings.md};
  `
);
const ArchiveIndicesInfo = ({ indexSetOverview }) => {
  var _a;
  if (!indexSetOverview) return null;
  const indicesCount = indexSetOverview.indices.length;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "success" }, indicesCount, " indices with a total of ", numeral(indexSetOverview.counts.events).format("0,0"), " messages under management, current write-active index is ", /* @__PURE__ */ React.createElement("i", null, (_a = indexSetOverview.deflector.current_target) != null ? _a : "none"), "."), /* @__PURE__ */ React.createElement(HideOnCloud, null, /* @__PURE__ */ React.createElement(IndexerClusterHealthSummary, { health: indexSetOverview.indexer_cluster.health })));
};
export default ArchiveIndicesInfo;
